if (!customElements.get('product-bundle')) {
  class ProductBundle extends HTMLElement {
    constructor() {
      super()
      this.defaultImage = this.dataset.defaultImage;
      this.image = this.querySelector('[data-image] img');
      this.variantSelector = this.querySelector('[data-variant-selector]');
    }

    connectedCallback() {
      this.attachEvents()
    }

    attachEvents() {
      this.variantSelector.addEventListener('change', this.changeVariant.bind(this));
    }

    changeVariant() {
      const activeOption = this.variantSelector.querySelector(`option[value="${this.variantSelector.value}"]`);
      const variantTitle = activeOption.textContent === 'Select option' ? '' : activeOption.textContent;
      const available = activeOption.dataset.available || false;

      this.changeImage(activeOption);

      document.dispatchEvent(new CustomEvent('dcb:change-bundle-variant', { detail: { id: this.variantSelector.value, variantTitle: variantTitle, available: available }}));
    }

    changeImage(activeOption) {
      if (!this.image) return;

      const imageSrc = activeOption?.dataset.variantImage || this.defaultImage;

      this.image.src = imageSrc;
    }
  }

  customElements.define('product-bundle', ProductBundle)
}
